"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_1 = require("react");
const utils_1 = require("../utils");
const parseReadValue = (value) => {
    try {
        return JSON.parse(value);
    }
    catch (e) {
        console.warn(`Could not parse value read from sessionStorage.`, e);
    }
    return value;
};
const readValue = (key) => {
    if (utils_1.isBrowser()) {
        try {
            return window.sessionStorage.getItem(key);
        }
        catch (e) {
            console.warn(`Could not read "${key}" from sessionStorage.`, e);
        }
    }
    return undefined;
};
const stringifyWriteValue = (value) => {
    try {
        return value && lodash_1.isObject(value) ? JSON.stringify(value) : value;
    }
    catch (e) {
        console.warn(`Could not stringify value before writing it to sessionStorage.`, e);
    }
    return value;
};
const writeValue = (key, value) => {
    if (utils_1.isBrowser()) {
        try {
            window.sessionStorage.setItem(key, value);
        }
        catch (e) {
            console.warn(`Could not write "${key}" to sessionStorage.`, e);
        }
    }
};
const useSessionStorage = (key) => {
    // Use `useState` to prevent `sessionStorage` from being
    // accessed on every rerun of this hook.
    const [value, setValue] = react_1.useState(() => {
        const rawValue = readValue(key);
        return rawValue ? parseReadValue(rawValue) : rawValue;
    });
    react_1.useEffect(() => {
        const rawValue = readValue(key);
        setValue(rawValue ? parseReadValue(rawValue) : rawValue);
    }, [key]);
    react_1.useEffect(() => {
        const stringifiedValue = stringifyWriteValue(value);
        writeValue(key, stringifiedValue);
    }, [key, value]);
    return [value, setValue];
};
exports.default = useSessionStorage;
